import { render } from "./Void.vue?vue&type=template&id=2c8c0629"
import script from "./Void.vue?vue&type=script&lang=js"
export * from "./Void.vue?vue&type=script&lang=js"
script.render = render

export default script